import React from "react";

// Archery target logo (black -> blue -> red -> yellow concentric circles)
export const TargetIcon = ({ size = 44 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
  >
    <circle cx="50" cy="50" r="49" fill="#e2e2e2" />
    <circle cx="50" cy="50" r="43" fill="#111111" />
    <circle cx="50" cy="50" r="31" fill="#33aaee" />
    <circle cx="50" cy="50" r="20" fill="#e01e1e" />
    <circle cx="50" cy="50" r="10" fill="#f7d417" />
  </svg>
);

const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-2">
    <TargetIcon size={compact ? 34 : 44} />
    <span
      className="font-black tracking-tight text-[#111111]"
      style={{ fontSize: compact ? "20px" : "26px", letterSpacing: "-0.5px" }}
    >
      Morningsundayteer
    </span>
  </div>
);

export default Logo;
